module.exports = __webpack_public_path__ + "img/9788937460777.0d7a300a.jpg";